export function downloadFile (response) {
  const { headers, data } = response
  // extract filename from the content-disposition and ge tthe streamReader
  const filename = headers['content-disposition'].split("filename=")[1];
  const contentType = headers['content-type']
  const blob = new Blob([data], {type: contentType});
  const url = window.URL.createObjectURL(blob);
  // create a link and bind it to download the blob
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  // add link on the document, click it
  document.body.appendChild(link);
  link.click();

  setTimeout(function () {
    // then clean
    document.body.removeChild(link)
    window.URL.revokeObjectURL(url);
  }, 100);
}
